import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const BoldTitle = styled.div`
  width: fit-content;
  font-size: 24px;
  font-family: Circular-Std-Bold;
  color: ${colors.titleStrongBlack};

  @media screen and (max-width: 550px){
    font-size: 22px;
  }
`
